"use client";
import { Controller, FieldValues } from "react-hook-form";
import { FormInputControllerProps } from "./Common/FormInputControllerProps";
import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormControlProps,
  FormHelperText,
  FormHelperTextProps,
} from "@mui/material";
import { getFormError } from "./Common/utils";

interface CheckboxInputProps<T extends FieldValues>
  extends FormInputControllerProps<T> {
  label?: string | React.JSX.Element;
  disabled?: boolean;
  CheckboxProps?: Omit<CheckboxProps, "onChange" | "checked">;
  FormControlProps?: Omit<FormControlProps, "error">;
  FormControlLabelProps?: Omit<FormControlLabelProps, "control" | "label">;
  FormHelperTextProps?: FormHelperTextProps;
}

export function CheckboxInput<T extends FieldValues>(
  props: CheckboxInputProps<T>,
) {
  return (
    <Controller
      {...props.ControllerProps}
      name={props.propertyName}
      control={props.control}
      render={({ field, fieldState, formState: { errors } }) => {
        const formError = getFormError(props.propertyName, errors);
        return (
          <FormControl
            disabled={props.disabled}
            {...props.FormControlProps}
            error={!!formError}
          >
            <FormControlLabel
              {...props.FormControlLabelProps}
              label={props.label}
              control={
                <Checkbox
                  {...props.CheckboxProps}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                  }}
                  checked={!!field.value}
                />
              }
            />
            {formError ? (
              <FormHelperText {...props.FormHelperTextProps}>
                {formError}
              </FormHelperText>
            ) : undefined}
          </FormControl>
        );
      }}
    />
  );
}
